<template>
    <div class="main">
        <global-tag>
            <span slot="title">沿街门面</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="单位名称：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.facadeName"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                    class="button openBtns"
                    size="mini"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    class="button downOutBtns"
                    size="mini"
                    @click="createExcel"
                    >导出</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
                    <span>导入</span>
                </label>
                <el-button
                    type="danger"
                    class="button"
                    size="mini"
                    @click="deleteItem"
                    >删除</el-button
                >
                <a target="_blank" class="domModel modelDownds" @click="createExcel1"
                    >下载模板</a
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="行业类别"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="单位名称"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="法人代表"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="统一社会信用代码"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="注册地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="办公地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="成立时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="主要业务活动"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="营业状态"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="员工数"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="面积"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="年营业收入"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="年税收"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="税收主管局"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="备注"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="标准地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                ref="multipleTable"
                @row-click="openDetails"
                @selection-change="handleSelectionChange"
                :header-cell-style="{
                    background: '#e6e6e6',
                    color: '#000',
                }"
                border
            >
                <el-table-column
                    type="selection"
                    width="55"
                    @selection-change="handleSelectionChange"
                >
                </el-table-column>
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="行业类别"
                    align="center"
                    prop="industryCategory"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '行业类别'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.industryCategory == 1"
                            >商贸业</span
                        >
                        <span v-if="scope.row.industryCategory == 2"
                            >服务业</span
                        >
                        <span v-if="scope.row.industryCategory == 3"
                            >建筑业</span
                        >
                        <span v-if="scope.row.industryCategory == 4">工业</span>
                        <span v-if="scope.row.industryCategory == 5"
                            >房地产开发业</span
                        >
                        <span v-if="scope.row.industryCategory == 6">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="单位名称"
                    align="center"
                    prop="facadeName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '单位名称'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="法人代表"
                    align="center"
                    prop="legalRepresentative"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '法人代表'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="联系电话"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="统一社会信用代码"
                    align="center"
                    prop="creditCode"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '统一社会信用代码'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="注册地址"
                    align="center"
                    prop="businessAddress"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '注册地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="办公地址"
                    align="center"
                    prop="businessAddress"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '办公地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="成立时间"
                    align="center"
                    prop="regtime"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '成立时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="主要业务活动"
                    align="center"
                    prop="businessActivity"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '主要业务活动'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="营业状态"
                    align="center"
                    prop="operatingState"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '营业状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.operatingState == 1">正常</span>
                        <span v-if="scope.row.operatingState == 2">关闭</span>
                        <span v-if="scope.row.operatingState == 3">迁出</span>
                        <span v-if="scope.row.operatingState == 4"
                            >联系不上</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="员工数"
                    align="center"
                    prop="staffNumber"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '员工数'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="面积"
                    align="center"
                    prop="area"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '面积'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="年营业收入"
                    align="center"
                    prop="income"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '年营业收入'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="年税收"
                    align="center"
                    prop="tax"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '年税收'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="税收主管局"
                    align="center"
                    prop="taxDepartment"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '税收主管局'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="备注"
                    align="center"
                    prop="remark"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '名称'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="标准地址"
                    align="center"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标准地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    prop="counts"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span
                            >{{ scope.row.longitude }},{{
                                scope.row.latitude
                            }}</span
                        >
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建时间"
                    align="center"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑时间"
                    align="center"
                    prop="updateDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑人"
                    align="center"
                    prop="updatePersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    width="240px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                @click="addServices('查看', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看</span
                            >
                            <span
                                @click="addServices('编辑', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >编辑</span
                            >
                            <span
                                @click="seeMap(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看地图定位</span
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
        <map-info
            v-if="mapState"
            :openData="mapInfo"
            @cancleService="cancleService"
        ></map-info>
    </div>
</template>
<script>
import globalTag from "../../../../components/globalTag"
import addService from "./components/addService"
import mapInfo from "@/components/mapInfo"
import request from "@/utils/request.js"
export default {
    name: "serviceMange",
    inject: ["reload"], //注入
    components: {
        globalTag,
        addService,
        mapInfo,
    },
    data() {
        return {
            selectedData: [],
            mapState: false,
            mapInfo: {},
            sexOptions: [
                {
                    value: "0",
                    label: "男",
                },
                {
                    value: "1",
                    label: "女",
                },
            ],
            pageOne: {
                total: 0,
                pageSize: 10,
                pageNo: 1,
            },
            tableData: [],
            queryInfo: {},
            serviceState: false,
            serviceInfo: {},

            tempTableChekbox: [
                "序号",
                "行业类别",
                "单位名称",
                "法人代表",
                "联系电话",
                "统一社会信用代码",
                "办公地址",
                "注册地址",
                "成立时间",
                "主要业务活动",
                "营业状态",
                "员工数",
                "面积",
                "年营业收入",
                "年税收",
                "税收主管局",
                "备注",
                "标准地址",
                "点位坐标",
                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "行业类别",
                "单位名称",
                "法人代表",
                "联系电话",
                "统一社会信用代码",
                "办公地址",
                "注册地址",
                "成立时间",
                "主要业务活动",
                "营业状态",
                "员工数",
                "面积",
                "年营业收入",
                "年税收",
                "税收主管局",
                "备注",
                "标准地址",
                "点位坐标",
                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 查看定位
        seeMap(row) {
            this.mapState = true
            this.mapInfo = {
                address: row.address,
                longitude: row.longitude,
                latitude: row.latitude,
                provinceId: row.provinceId,
                cityId: row.cityId,
                zoneId: row.zoneId,
                streetId: row.streetId,
                shequId: row.shequId,
                id: row.id,
                state: true,
            }
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                facadeName: this.queryInfo.facadeName,
            }
            this.$http
                .request({
                    url: "/ypt/admin/streetFront/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        if (res.content.list.length > 0) {
                            res.content.list.forEach((item) => {
                                item.hasChagned =
                                    Number(item.counts) - Number(item.stock)
                            })
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },

        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false
            this.mapState = false
            this.signState = false
            if (state == true) {
                this.getList()
            }
        },

        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true

            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },

        // 页面刷新
        reset() {
            this.reload()
        },
        // 搜索
        querySearch() {
            this.getList()
        },
        //导出excel
        createExcel() {
            this.request2({
                url: "/ypt/admin/streetFront/info/downloadExcel",
                method: "POST",
                excel: true,
                data: {},
                responseType: "blob",
            }).then((res) => {
                console.log("adsasd")
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "沿街门面信息.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
            // const res = await request2({
            //     url: "/ypt/admin/publicHealth/info/downloadExcel",
            //     method: "POST",
            //     data: {type:2},
            //     responseType: "blob",
            // })
            // const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            // const fileName = "楼栋信息.xls"
            // const linkNode = document.createElement("a")

            // linkNode.download = fileName //a标签的download属性规定下载文件的名称
            // linkNode.style.display = "none"
            // linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            // document.body.appendChild(linkNode)
            // linkNode.click() //模拟在按钮上的一次鼠标单击

            // URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            // document.body.removeChild(linkNode)
        },
        createExcel1() {
            this.request2({
                url: "/ypt/admin/streetFront/info/downloadExcel",
                method: "POST",
                excel: true,
                data: {
                    type: 0,
                },
                responseType: "blob",
            }).then((res) => {
                console.log("adsasd")
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "沿街门面信息.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/publicHealth/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },
        handleSelectionChange(data) {
            this.selectedData = data
            console.log(this.selectedData)
        },
        // 行点击选中
        openDetails(row, event, column, cell) {
            this.$refs.multipleTable.toggleRowSelection(row)
            this.row = row
            this.column = column
        },
        deleteItem() {
            var val = this.selectedData
            if (val.length > 0) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url: "/ypt/admin/streetFront/info/deleteById",
                                method: "POST",
                                data: {
                                    id: item.id,
                                },
                            })
                        })
                    })
                    .then(() => {
                        this.reset()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    })
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;

    .content {
        flex: 1;
    }
}

/deep/.table_title {
    margin-top: 15px !important;
}

/deep/.btn_group {
    margin-top: 0px !important;
}

.button {
    margin-bottom: 4px;
}

.labelImportBtn,
.domModel {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 0 17px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}

.domModel {
    background: green;
    text-decoration: none;
}

.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>
